export enum CreateDraftWorkflowVersionField {
  WorkflowId = 'workflowId',
  Description = 'description',
  Definition = 'definition',
}

export interface CreateDraftWorkflowVersionFormValues {
  [CreateDraftWorkflowVersionField.WorkflowId]: string;
  [CreateDraftWorkflowVersionField.Description]: string;
  [CreateDraftWorkflowVersionField.Definition]: string;
}
